import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { of, switchMap, timeout, catchError } from 'rxjs';
import { inject } from '@angular/core';

export const PermisoGuard: CanActivateFn = (route, state) => {
    const router = inject(Router);
    const auth = inject(AuthService);

    const fullPath = state.url.replace(/^\//, '');
    const shortPath = route.routeConfig?.path || '';
    const parentPath = fullPath.split('/')[0];

    const evaluarPermisos = () => auth.verificarRutasPermitidas(fullPath).pipe(
        switchMap(allowFull => {
            if (allowFull) {
                return of(true);
            }

            return auth.verificarRutasPermitidas(shortPath).pipe(
                switchMap(allowShort => {
                    if (allowShort) {
                        return of(true);
                    }

                    return auth.verificarRutasPermitidas(parentPath).pipe(
                        switchMap(allowParent => allowParent
                            ? of(true)
                            : of(router.createUrlTree(['/acceso-denegado'])))
                    );
                })
            );
        })
    );

    return auth.rutasListas$.pipe(
        switchMap(listas => {
            if (!listas) {
                return auth.loadRoutes().pipe(
                    timeout(10000),
                    catchError(() => of(void 0)),
                    switchMap(() => evaluarPermisos())
                );
            }

            return evaluarPermisos();
        })
    );
};
